import styled from '@emotion/styled';

export const Content = styled.div`
    @media screen {

        background-color: #edece8;
        height: 100%;
        min-height:100vh;
        
        .sekat{
            height:calc(70px + 3vw);
        }

        .buatCar{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom:50px;
        }

        .containerSearch{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom:50px;
        }

        .buatSearchBar{
            background-color:white;
            padding-left:20px;
            padding-right:20px;
            border-color: #fff;
            border-style: solid;
            border-radius: 100px;
            box-shadow: 0 0 10px 1px rgb(18 18 18 / 56%);
        }

        .nav-search{
            border-color:transparent;
            width:200px;
            transition: width 0.3s ease-in-out;
        }

        .nav-search:focus{
            border-color:transparent;
            outline: none;
            width:250px;
            transition: width 0.3s ease-in-out;
        }

        .buatList{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left:5vw;
            margin-right:5vw;
            min-height:calc(200px + 20vw);
            border-color: #fff;
            border-style: solid;
            border-radius: 15px;
            max-width: 100%;
            box-shadow: 0 0 10px 1px rgb(18 18 18 / 56%);
            background-color: #fffcf6
        }

        .nyoba{
            width:100%;
            padding:50px;
            word-wrap: break-word;
        }

        .tes{
            width: 100%;
            word-wrap: break-word;
            white-space: pre-wrap;
            font-size:20px;
            text-indent:100px;
        }

        
            
        `;
